import { Box, Stack } from '@mui/material';

import { SkeletonBlock } from '@mopla/ui';

import {
	StyledOperatorCardBox,
	StyledOperatorDescription,
	StyledOperatorImageWrapper,
	StyledOperatorTitleRow,
} from './OperatorCard.styled';

export const OperatorCardSkeleton = () => {
	return (
		<StyledOperatorCardBox data-testid="operator-card-skeleton">
			<StyledOperatorImageWrapper>
				<StyledOperatorTitleRow>
					<SkeletonBlock w={24} h={24} r={24} />
					<Box sx={{ flex: 1 }}>
						<SkeletonBlock w="60%" h={18} r={6} />
					</Box>
				</StyledOperatorTitleRow>
			</StyledOperatorImageWrapper>

			<StyledOperatorDescription>
				<Stack gap={0.5}>
					<SkeletonBlock w="90%" h={14} r={6} />
					<SkeletonBlock w="70%" h={14} r={6} />
				</Stack>
			</StyledOperatorDescription>
		</StyledOperatorCardBox>
	);
};
